// @ts-nocheck There is so much bad GTM Elgentos code in this file, we don't want to check it all and potentially break it
import _ from 'lodash';
import { useSizeStore } from '@/stores/Configurator/SizeStore';
import { useExtraOptionsStore } from '@/stores/ExtraOptionsStore';
import { ConfigurableCollectionProductObject } from '@/types/joostconnector';

export function useGoogleTagManager() {
  const extraOptionsStore = useExtraOptionsStore();

  function performCallback(callback: CallableFunction): void {
    if (callback === undefined) {
      return;
    }

    callback();
  }

  function isLoaded(): boolean {
    return window.dataLayer.push.toString().indexOf('native code') < 0;
  }

  function triggerEventCallbackOnlyOnce(callback: CallableFunction) {
    let isTriggered = false;
    return function () {
      isTriggered =
        isTriggered || (undefined !== callback && callback()) || true;
    };
  }

  function dataLayerWithCallback(data, forwardErrors = false): void {
    // Async. so no returns
    // Tell if errors should be forwarded from here
    forwardErrors = forwardErrors || false;

    try {
      // make sure the event is triggered only once
      if (data.eventCallback !== undefined) {
        data.eventCallback = triggerEventCallbackOnlyOnce(data.eventCallback);
      }

      // Don't create datalayer, an error should emerge if it isn't initialized
      window.dataLayer.push(data);
    } catch (error) {
      // Fire callback to make sure this one is executed
      performCallback(data.eventCallback);

      if (forwardErrors) {
        throw error;
      }

      return;
    }

    // Trigger callback if not loaded
    if (!isLoaded()) {
      performCallback(data.eventCallback);
    }
  }

  dataLayerWithCallback.fetchValueFromDataLayer = function (
    defaultValue,
    ...requestKeys
  ) {
    if (!window.dataLayer) {
      return defaultValue;
    }

    const returnValue = requestKeys.reduce(function (value, key) {
      if (!value || !value[key]) {
        return null;
      }

      return value[key];
    }, window.dataLayer);

    return returnValue ?? defaultValue;
  };

  function triggerConfiguratorAddToCartEvent(): void {
    const selectedSizeValue = useSizeStore().selectedSizeValue;
    triggerAddToCartEvent(
      selectedSizeValue.label,
      window.product.name,
      selectedSizeValue.attributes.price / 100
    );
  }

  function triggerCollectionAddToCartEvent(
    selectedEndProductValue: ConfigurableCollectionProductObject
  ): void {
    triggerAddToCartEvent(
      selectedEndProductValue.webshopName,
      selectedEndProductValue.productName,
      selectedEndProductValue.price
    );
  }

  function triggerAddToCartEvent(
    format: string,
    name: string,
    price: number
  ): void {
    if (!window.dataLayer || !typeof dataLayerWithCallback === 'function') {
      return;
    }

    dataLayerWithCallback({
      event: 'add_to_cart',
      transactionProducts: [
        {
          format: format,
          name: name,
          price: Number(price.toFixed(2)),
          productId: window.product.entity_id,
          quantity: 1,
          sku: window.product.sku,
          variant:
            null +
            '-' +
            _.map(extraOptionsStore.selectedOptions, 'sku').join('-'),
          url: window.product_url,
        },
      ],
    });
  }

  window.dataLayerWithCallback = dataLayerWithCallback;

  return {
    dataLayerWithCallback,
    triggerConfiguratorAddToCartEvent,
    triggerCollectionAddToCartEvent,
  };
}
